// client and server can read from this config file. not secure
interface Config {
  baseApi: string;
  hotpadsApi: string;
  zgApi: {
    development: string;
    production: string;
    comet1: string;
  };
  defaultZgApi: string;
  version: string;

  defaultBrand: Brand;
  brands: Record<Brand, Brand>;
  brandUrls: Record<Brand, string>;
  supportedBrands: Record<string, boolean>;
  brandHostnames: Record<Brand, string>;
}

const sharedConfig: Config = {
  // cdn: '//nodes3cdn.hotpads.com/dist/rental-manager-web/',

  baseApi: 'renter-hub-api/api/v1',
  hotpadsApi: 'api/v2',
  zgApi: {
    development: 'https://localhost:8443',
    production: 'https://rental-manager-api.hotpads.com',
    comet1: 'https://comet1.testpads.net',
  },
  defaultZgApi: 'https://comet1.testpads.net',
  // this should probably be in serverConfig if it uses process.env
  version: process.env.npm_package_version || '0.0.0',

  defaultBrand: 'hotpads',
  brands: {
    hotpads: 'hotpads',
    zillow: 'zillow',
  },
  brandUrls: {
    hotpads: 'https://hotpads.com/auth-test',
    zillow: 'https://zillow.com/auth-test',
  },

  supportedBrands: {
    hotpads: true,
    zillow: true,
    trulia: false,
  },

  // todo: reword this, very hotpads specific
  brandHostnames: {
    hotpads: 'https://hotpads.com',
    zillow: 'https://www.zillow.com',
  },
};

export default sharedConfig;
